import noticeError from "./notice-error";
import { requestHelper } from "./request-helper";

export const createCompetitionEntry = async (
  url,
  payload,
  displayCompetitionEntryError
) => {
  try {
    const response = await requestHelper.post({
      url,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: payload,
    });
    return response?.data;
  } catch (error) {
    displayCompetitionEntryError && displayCompetitionEntryError();
    noticeError(error);
    throw error;
  }
};
